<template>
  <div class="acts-editor-info">
    <divider orientation="left">Сведения об этапах</divider>
    <div class="acts-editor-info__stages-select">
      <row :gutter="16">
        <i-col span="24">
          <span class="ms-help label">Включенные в акт этапы</span>
          <i-select
            v-model="stages"
            size="default"
            multiple
            placeholder="Выберите этапы"
            :max-tag-count="1"
            @on-change="changeStages"
            :disabled="!getContractModulePerms('contract_acts', 'update')"
          >
            <i-option
              v-for="stage in roadmap"
              class="acts-editor-info__option"
              :value="stage.id"
              :label="stage.name"
              :key="stage.id"
              :disabled="stage.cost_lag === 0"
            >
              <span :title="stage.name" class="acts-editor-info__option-item">{{ stage.name }}</span>
              <span class="acts-editor-info__option-costs ms-help">
                (не закрыто {{ getFormattedCosts(stage.cost_lag, true) }})
              </span>
            </i-option>
          </i-select>
        </i-col>
      </row>
    </div>
    <div class="acts-editor-info__stages-stat" v-if="filteredRoadmaps.length">
      <div class="ms-help label">
        Укажите сумму для акта по каждому из выбранных этапов
      </div>
      <card dis-hover :padding="8">
        <ul class="acts-editor-info__stages-list">
          <li
            class="acts-editor-info__stages-item"
            v-for="item in filteredRoadmaps"
            :key="item.id"
          >
            <div class="acts-editor-info__stages-info">
              <div class="acts-editor-info__stages-name ms-small-head">
                {{ item.name }}
              </div>
              <div class="acts-editor-info__stages-subinfo ms-help">
                {{ formatDefaultDate(item.roadmap_start_date) }} -
                {{ formatDefaultDate(item.roadmap_end_date) }}. Доступная сумма:
                {{ getFormattedCosts(item.cost_lag, false, withVat) }}
              </div>
            </div>
            <div class="acts-editor-info__stages-cost">
              <div class="ms-help labe">Сумма</div>
              <input-number
                v-model="item.costs"
                :min="0"
                :max="item.cost_lag"
                :formatter="costsFormatter"
                :parser="costsParser"
                size="default"
                :disabled="!getContractModulePerms('contract_acts', 'update')"
              />
            </div>
            <div :class="`acts-editor-info__stages-prepaid ${contractHasPrepaid ? 'acts-editor-info__stages-prepaid--active' : ''}`">
              <div class="ms-help label">В т.ч. аванс</div>
              <input-number
                v-model="item.prepaid_value"
                :min="0"
                :max="item.costs"
                :formatter="costsFormatter"
                :parser="costsParser"
                size="default"
                :disabled="!getContractModulePerms('contract_acts', 'update')"
              />
            </div>
          </li>
        </ul>
      </card>
    </div>
  </div>
</template>

<script>
import {
  costsFormatter,
  costsParser,
  getFormattedCosts,
  formatDefaultDate
} from '@/utils'

export default {
  props: ['contract', 'roadmap', 'act', 'act-modal'],
  data () {
    return {
      stages: []
    }
  },
  watch: {
    '$props.actModal' () {
      this.stages = this.act.act_roadmaps.map(r => r.roadmap_id)
    }
  },
  computed: {
    withVat () {
      return this.$store.state.contracts.current.with_vat
    },
    initialRoadmaps () {
      return this.roadmap.filter(r => r.cost_lag)
    },
    filteredRoadmaps () {
      return this.act.act_roadmaps.filter(r => !r.disabled)
    },
    contractHasPrepaid () {
      return this.contract && !!this.contract.prepaid
    }
  },
  methods: {
    changeStages (values) {
      const { act_roadmaps } = this.act
      const current = act_roadmaps
        .filter(r => !r.disabled)
        .map(r => r.roadmap_id)

      const added = values.filter(id => !current.includes(id))
      const removed = current.filter(id => !values.includes(id))

      if (added.length) {
        const [newId] = added
        const stage = this.roadmap.find(r => r.id === newId)
        const addedObject = act_roadmaps.find(r => r.roadmap_id === newId)

        if (addedObject) {
          this.$set(addedObject, 'disabled', false)
        } else {
          this.act.act_roadmaps.push({
            roadmap_id: newId,
            costs: 0,
            ...stage,
            prepaid_value: 0,
            id: undefined
          })
        }
      }

      if (removed.length) {
        const [removedId] = removed
        const removedObject = act_roadmaps.find(
          r => r.roadmap_id === removedId
        )

        if (removedObject.id) {
          this.$set(removedObject, 'disabled', true)
        } else {
          this.act.act_roadmaps.splice(
            this.act.act_roadmaps.indexOf(removedObject),
            1
          )
        }
      }
    },
    costsFormatter,
    costsParser,
    getFormattedCosts,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.acts-editor-info {
  &__stages-select {
    margin-bottom: 8px;

    .ivu-select {
      width: 100%;
    }

    &-info {
      margin: 4px 0;

      .ms-text,
      .ms-help {
        font-size: 11px;
      }
    }
  }

  &__option {
    display: flex;
    align-items: center;

    &-item {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 320px;
    }

    &-costs {
      margin-left: 8px;
      font-size: 11px;
    }
  }

  &__stages-list {
    list-style-type: none;
  }

  &__stages-item {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .ivu-input-number {
      width: 132px;
    }
  }

  &__stages-stat {
    margin-top: 12px;
  }

  &__stages-subinfo {
    font-size: 11px;
  }

  &__stages-cost {
    margin-left: auto;
  }

  &__stages-prepaid {
    margin-left: 16px;

    &--active {
      .ms-help {
        color: @danger-color;
      }

      .ivu-input-number {
        border-color: @danger-color !important;
      }
    }
  }
}
</style>
